import { useEffect, useRef } from 'react';
import { useAuth } from '@/lib/AuthContext';
import { createSignupConversionReporter } from '@/lib/googleAdsConversions';

export default function SignupConversion() {
  const { user } = useAuth();
  const reporter = useRef(null);
  if (!reporter.current) reporter.current = createSignupConversionReporter();

  useEffect(() => {
    // No consent-change replay, retry timer, direct gtag call or outbound user ID.
    reporter.current(user);
  }, [user]);
  return null;
}

